// extracted by mini-css-extract-plugin
export default {"modal":"UpsertTemplateModal_modal__fgl1S","section":"UpsertTemplateModal_section__Wn-12","materialsSection":"UpsertTemplateModal_materialsSection__3W9x2"};